import {BasicSelect,MultiSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../shared/components/pagination';
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import Loader from '../../../shared/components/loader';
import CONSTANT from './../../../shared/constants/constant';
import Util from './../../../shared/util/util';
import Treeselect from '@riophae/vue-treeselect';
import TripServices from './../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import XLSX from 'xlsx';
import Multiselect from 'vue-multiselect'
const moment = require('moment');

export default {
  name: 'FTCSettlementReportLisitng',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Loader,
    TripServices,
    Multiselect
  },
  data: function() {
    return {
  createFtcRadShipment:false,
  isLoading:false,
  CashMemo: "",
  banklist: [],
  bankName:null,
  selectedBankName:"",
  branchlist: [],
  branchName:"",
  Accountlist:[],
  accountNumber:null,
  tripCloseToDate:'',
  tripCloseFromDate:'',
  tripID:'',
  depositToDate:'',
  depositFromDate:'',
  depositSlipNumber:'',
  cashDepositID:'',
  reportData:"",
  totalPage: 0,
  showDeposit:false,
  currentPage: 1,
  total: 0,
  totalCount: 0,
  perPage: 0,
  hubname:'',
  pageLimit: CONSTANT.PER_PAGE_DATA,
  offset: 0,
  bankmasterlist:'',
  radToDate: "",
  selectedHub:null,
  radFromDate: "",
  companyName: "",
  modalData:'',
  HubList:[],
  AWB: "",
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss').valueOf()
    }
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.hubid = userdetail.hubID[0];
    this.hubname = userdetail.currentHubName;
    await Promise.all([
      this.getSettlementReport(),
      this.getHublist(),
      this.getbanklisitng()
    ]
    )
  },
  methods: {
    selectBank(el){
      let bankRecord = this.bankmasterlist.find(item=>item.BankMasterId == el.id);
      this.selectedBankName = bankRecord.BankName; 
      this.accountNumber = bankRecord.AccountNo?bankRecord.AccountNo:'';
      this.branchName = bankRecord.BranchName?bankRecord.BranchName:'';
    },
    async getbanklisitng(){
      try {
        // this.isLoading = true;
        let result = await TripServices.getBankListing({});
        if(result.data.code == 200){
          this.bankmasterlist = result.data.data
          this.banklist = [];
          this.bankmasterlist.forEach(el=>{
            this.banklist.push({
              id : el.BankMasterId,
              label : el.BankName
            })
          })
        }
        // this.isLoading = false;
      } catch (err) {
        console.log(err)
        // this.isLoading = false;
      }
    },
    formatDate(date){
      if (date == null || date == '') return '--';
    return moment.utc(date).format('DD-MM-YYYY');
    },
    selecthub(data){
      this.selectedHub = data;
    },
    displayDeposit(data){
    this.modalData=data;
      this.showDeposit = true
    },
    async getHublist() {
      try {
        let InputPayload = {};
        let result = await TripServices.GetHublist(InputPayload);
        let HubList = result.data.data.data;
        for (var i = 0; i < HubList.length; i++) {
          this.HubList.push({
            'value': HubList[i].HubID,
            'text': HubList[i].HubName
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    reset(){
        this.cashDepositID = '';
        this.tripID = '';
        this.depositToDate = '';
        this.depositFromDate = '';
        this.depositSlipNumber = '';
        this.tripCloseFromDate = '';
        this.tripCloseToDate = '';
        this.branchName = null;
        this.bankName = null;
        this.selectedBankName = null;
        this.accountNumber= null;
        this.selectedHub = null;
        this.offset = 0;
        this.currentPage = 1;
        this.getSettlementReport();
    },
    async exportData(){
      try {
        var data = await this.getSettlementReport(1);
        this.isLoading = true;
        if(data && data.data.code == 200){
          var tempdata = [];
            data.data.data.rows.map((el,id)=>{
            tempdata.push({
              'Sr No': id+1,
              'Hub' : `${this.selectedHub?this.selectedHub.text:this.hubname}(${el.hubid})`,
              'Trip Id' : el.tmstripid ? el.tmstripid : 'Consignee pickup',
              'Trip End Date' : el.tmstripid ? this.formatDate(el.tripenddate) : "NA",
              'AWB' : el.awb,
              'FTC Amount (INR)': el.ftctotalamtwogst ? this.calculatePercent(el.ftctotalamtwogst,18)  : Number(el.ftcamount),
              'TDS Amount (INR)': el.tdsdeductedamount,
              'Amount Collected (INR)' : Number(el.ftccashpayment),
              'Total Amount Deposited' : Number(el.ftccashpayment) - Number(el.ftcsettlementpendingamt),
              "Deposit ID": el.ftcdepositid ? el.ftcdepositid.join(','):'',
              'Delivery Date and Time': el.tmstripid ? el.awbdeliverydate ? this.formatDate(el.awbdeliverydate) :"" : "NA",
              // Deposit Status and date need to fetch
              'Deposit Date': el.depositdate ? Util.displayDateOnlyFormat(el.depositdate) : '',
              'Deposit by': el.depositby ? el.depositby : '',
              'Deposit Creation Date': el.depositcreateddate ? Util.displayDateOnlyFormat(el.depositcreateddate) : '',
              'Finance Verification Date': (el.depositsstatus === 1 || el.depositsstatus === 2) ? Util.displayDateOnlyFormat(el.depositlastmodifieddate) : '',
              "Verified by": (el.depositsstatus === 1 || el.depositsstatus === 2) ? el.depositlastmodifiedby : '',
              "Settlement status" : el.ftcamountsettled?'Settled':'Unsettled'
            });
          }) 
          let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          const data1 = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data1, 'data')
          XLSX.writeFile(wb,dt+'tripData.xlsx');
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
        this.isLoading = false;
      }
    },
    calculatePercent(value,percent){
      let gst =  Number(Number((value/100)*percent).toFixed(2)) ;
      console.log(gst,"gst");
      console.log("value",value)
      
      return Math.round(Number(Number(value) + Number(gst)))
    },
    search(){
      this.offset = 0;
      this.currentPage = 1;
      this.getSettlementReport(0)
    },
    async getSettlementReport(flag = 0){
      try {
        this.isLoading = true;
        let reqPaylaod = {
          hubid:this.hubid,
          offset: this.offset,
          limit: this.pageLimit,
        }
        if(this.selectedHub){
          reqPaylaod.hubid = this.selectedHub.value
        }
        if(this.cashDepositID){
          reqPaylaod.cashdepositid = this.cashDepositID
        }
        if(this.tripID){
          reqPaylaod.tripid = this.tripID
        }
        if(this.depositToDate){
          reqPaylaod.deposittodate = this.depositToDate
        }
        if(this.depositFromDate){
          reqPaylaod.depositfromdate = this.depositFromDate
        }
        if(this.depositSlipNumber){
          reqPaylaod.depositslipnumber = this.depositSlipNumber
        }
        if(this.tripCloseFromDate){
          reqPaylaod.tripclosefromdate = this.tripCloseFromDate
        }
        if(this.tripCloseToDate){
          reqPaylaod.tripclosetodate = this.tripCloseToDate
        }
        if(this.selectedBankName){
          reqPaylaod.bankname = this.selectedBankName
        }
        if(this.branchName){
          reqPaylaod.branchname = this.branchName
        }
        if(this.accountNumber){
          reqPaylaod.accountnumber = this.accountNumber;
        }
        if(flag){
          reqPaylaod.exportflag = 1;
        }
        let data = await TripServices.getSettlementReportListing(reqPaylaod)
        if(data.data.code == 200){
          if(flag){
            this.isLoading = false;
            return data;
          }
          this.reportData = data.data.data.rows
          this.totalCount = data.data.data.count
        }else{
          if(flag) {
            this.isLoading = false;
            return;
          }
          this.totalCount = 0
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error)
        this.isLoading = false;
      }
    },
    callParent() {
        this.createFtcRadShipment = false;
      },
      showCreateFTCShipment() {
        this.createFtcRadShipment = true;
      },
      onPageChange(page) {
        this.currentPage = page;
        this.offset = (page - 1) * this.pageLimit
        this.getSettlementReport();
      },
getCustomTableEvent(){}
},

}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/SettlementReport/SettlementReport.component.js